// import { useState, useMemo } from "react";
// import {
//   DndContext,
//   closestCenter,
// } from "@dnd-kit/core";
// import {
//   SortableContext,
//   verticalListSortingStrategy,
//   useSortable,
//   arrayMove,
// } from "@dnd-kit/sortable";
// import { CSS } from "@dnd-kit/utilities";

// import ConfirmModal from "components/common/ConfirmModal";
// import ImageViewer from "components/common/ImageViewer";
// import { MdEdit, MdDelete } from "react-icons/md";
// import { getImageUrl } from "utils/imageHelper";
// import { useBanners } from "components/banners/hooks/useBanners";



// function SortableRow({ banner, onEdit, onAskDelete, openViewer }) {
//   const { attributes, listeners, setNodeRef, transform, transition } =
//     useSortable({ id: banner._id });

//   const style = {
//     transform: CSS.Transform.toString(transform),
//     transition,
//   };

//   const isVideoFile = (path = "") =>
//   /\.(mp4|webm|ogg)$/i.test(path);

    

//   return (
//     <tr
//       ref={setNodeRef}
//       style={style}
//       className="hover:bg-gray-50 transition"
//     >
//       <td
//         {...attributes}
//         {...listeners}
//         className="px-4 cursor-move text-gray-400 text-lg"
//         title="Drag to reorder"
//         onClick={(e) => e.stopPropagation()}
//       >
//         ⠿
//       </td>

//       <td className="px-6 py-4">
//        {banner.media_type === "video" && banner.banner_video ? (
//         <video
//           src={getImageUrl(banner.banner_video)}
//           className="h-12 w-20 rounded-lg border object-cover cursor-pointer"
//           muted
//           playsInline
//           onClick={(e) => {
//           e.stopPropagation();
//           openViewer({
//             url: banner.banner_video,
//             type: "video",
//           });
//         }}
//         />
//       ) : banner.banner_image ? (
//         <img
//           src={getImageUrl(banner.banner_image)}
//           alt={banner.title}
//           className="h-12 w-20 rounded-lg object-cover border cursor-pointer"
//           onClick={(e) => {
//             e.stopPropagation();
//             openViewer({
//               url: banner.banner_image,
//               type: "image",
//             });
//           }}

//         />
//       ) : (
//         <div className="h-12 w-20 rounded-lg bg-gray-100 flex items-center justify-center text-xs text-gray-400">
//           no media
//         </div>
//       )}

//       </td>

//       <td className="px-6 py-4 font-medium text-gray-800">
//         {banner.title}
//       </td>

//       <td className="px-6 py-4">
//         <span
//           className={`rounded-full px-3 py-1 text-xs font-semibold ${
//             banner.status === "live"
//               ? "bg-green-100 text-green-700"
//               : "bg-gray-200 text-gray-600"
//           }`}
//         >
//           {banner.status}
//         </span>
//       </td>

//       <td className="px-6 py-4">
//         <div className="flex justify-end gap-3">
//           <button
//             onClick={() => onEdit(banner)}
//             className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-blue-600"
//             title="Edit"
//           >
//             <MdEdit size={18} />
//           </button>

//           <button
//             onClick={() => onAskDelete(banner._id)}
//             className="rounded-lg p-2 text-gray-600 hover:bg-red-50 hover:text-red-600"
//             title="Delete"
//           >
//             <MdDelete size={18} />
//           </button>
//         </div>
//       </td>
//     </tr>
//   );
// }


// export default function BannerTable({
//   bannerType,
//   data = [],
//   loading,
//   onEdit,
//   onDelete,
//   onReorder,
// }) {
//   const banners = Array.isArray(data?.data) ? data.data : [];

//   const [deleteId, setDeleteId] = useState(null);
//   const [deleting, setDeleting] = useState(false);

//   const [viewerOpen, setViewerOpen] = useState(false);
//   const [viewerSrc, setViewerSrc] = useState(null);
//   const [viewerData, setViewerData] = useState(null);
  

//   const sortedBanners = useMemo(
//     () =>
//       [...banners].sort(
//         (a, b) => (a.priority_order || 0) - (b.priority_order || 0)
//       ),
//     [banners]
//   );

//   const handleDragEnd = async (event) => {
//     const { active, over } = event;
//     if (!over || active.id === over.id) return;

//     const oldIndex = sortedBanners.findIndex(
//       (b) => b._id === active.id
//     );
//     const newIndex = sortedBanners.findIndex(
//       (b) => b._id === over.id
//     );

//     const reordered = arrayMove(
//       sortedBanners,
//       oldIndex,
//       newIndex
//     );

//     const payload = reordered.map((b, index) => ({
//       _id: b._id,
//       priority_order: index + 1,
//     }));

//     await onReorder(payload);
//   };

//   const confirmDelete = async () => {
//     try {
//       setDeleting(true);
//       await onDelete(deleteId);
//       setDeleteId(null);
//     } finally {
//       setDeleting(false);
//     }
//   };

//   return (
//     <>
//       <div className="space-y-6">
//         <h2 className="text-xl font-semibold">
//           {bannerType} Banners
//         </h2>

//         <div className="overflow-hidden rounded-xl bg-white shadow-sm">
//           <DndContext
//             collisionDetection={closestCenter}
//             onDragEnd={handleDragEnd}
//           >
//             <SortableContext
//               items={sortedBanners.map((b) => b._id)}
//               strategy={verticalListSortingStrategy}
//             >
//               <table className="w-full text-left">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th className="px-4 py-4"></th>
//                     <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                       Image
//                     </th>
//                     <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                       Banner 
//                     </th>
//                     <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                       Status
//                     </th>
//                     <th className="px-6 py-4 text-right text-sm font-semibold text-gray-600">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody className="divide-y">
//                   {loading && (
//                     <tr>
//                       <td
//                         colSpan="5"
//                         className="px-6 py-10 text-center text-sm text-gray-500"
//                       >
//                         Loading...
//                       </td>
//                     </tr>
//                   )}

//                   {!loading &&
//                     sortedBanners.map((b) => (
//                       <SortableRow
//                         key={b._id}
//                         banner={b}
//                         onEdit={onEdit}
//                         onAskDelete={setDeleteId}
//                         openViewer={(data) => {
//                           setViewerData({
//                             url: getImageUrl(data.url),
//                             type: data.type,
//                           });
//                           setViewerOpen(true);
//                         }}

//                       />
//                     ))}

//                   {!loading && !sortedBanners.length && (
//                     <tr>
//                       <td
//                         colSpan="5"
//                         className="px-6 py-10 text-center text-sm text-gray-500"
//                       >
//                         No banners found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </SortableContext>
//           </DndContext>
//         </div>
//       </div>

//       <ConfirmModal
//         open={Boolean(deleteId)}
//         title="Delete Banner"
//         message="This action cannot be undone. Do you want to continue?"
//         confirmText="Delete"
//         loading={deleting}
//         onConfirm={confirmDelete}
//         onCancel={() => setDeleteId(null)}
//       />

//       <ImageViewer
//         open={viewerOpen}
//         onClose={() => setViewerOpen(false)}
//         src={viewerData?.url}
//         type={viewerData?.type}
//       >
//       </ImageViewer>

//     </>
//   );
// }

import { useState, useMemo, useEffect, useRef } from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import ConfirmModal from "components/common/ConfirmModal";
import ImageViewer from "components/common/ImageViewer";
import { MdMoreVert, MdEdit, MdDelete, MdAddBox } from "react-icons/md";
import { getImageUrl } from "utils/imageHelper";
import CustomButton from "components/CustomButton";

function SortableRow({
  banner,
  onEdit,
  onAskDelete,
  openViewer,
  openDropdownId,
  setOpenDropdownId,
  openUpward,
  setOpenUpward,
  dropdownRef,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: banner._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const isActive =
    banner.status?.toLowerCase() === "live" ||
    banner.status?.toLowerCase() === "active" ||
    banner.status === true;

  const isMenuOpen = openDropdownId === banner._id;

  const handleToggleMenu = (e) => {
    e.stopPropagation();
    if (isMenuOpen) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      if (spaceBelow < 150) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }

      setOpenDropdownId(banner._id);
    }
  };

  return (
    <tr ref={setNodeRef} style={style} className="custom-table-row">
      {/* Drag Handle */}
      <td
        {...attributes}
        {...listeners}
        className="custom-table-cell w-10 text-center cursor-move text-gray-400 hover:text-gray-600 text-lg"
        title="Drag to reorder"
        onClick={(e) => e.stopPropagation()}
      >
        ⠿
      </td>

      {/* Media Preview */}
      <td className="custom-table-cell">
        {banner.media_type === "video" && banner.banner_video ? (
          <video
            src={getImageUrl(banner.banner_video)}
            className="table-logo cursor-pointer object-cover"
            muted
            playsInline
            onClick={(e) => {
              e.stopPropagation();
              openViewer({
                url: banner.banner_video,
                type: "video",
              });
            }}
          />
        ) : banner.banner_image ? (
          <img
            src={getImageUrl(banner.banner_image)}
            alt={banner.title}
            className="table-logo cursor-pointer object-cover"
            onClick={(e) => {
              e.stopPropagation();
              openViewer({
                url: banner.banner_image,
                type: "image",
              });
            }}
          />
        ) : (
          <span style={{ fontSize: "10px", color: "#d1d5db" }}>No media</span>
        )}
      </td>

      {/* Banner Title */}
      <td className="custom-table-cell font-medium">
        {banner.title || "N/A"}
      </td>

      {/* Status Badge */}
      <td className="custom-table-cell text-center">
        <span
          className={`inline-block rounded-[8px] px-3 py-1 text-xs font-semibold ${
            isActive
              ? "bg-[#dcfce7] text-[#16a34a]"
              : "bg-[#f1f5f9] text-[#64748b]"
          }`}
        >
          {banner.status || "Inactive"}
        </span>
      </td>

      {/* Action Dropdown Menu Cell */}
      <td className="custom-table-cell relative text-center">
        <button onClick={handleToggleMenu} className="action-menu-btn">
          <MdMoreVert className="text-lg" />
        </button>

        {isMenuOpen && (
          <div
            ref={dropdownRef}
            className={`action-dropdown-menu ${
              openUpward ? "menu-bottom" : "menu-top"
            }`}
          >
            <button
              onClick={() => {
                onEdit(banner);
                setOpenDropdownId(null);
              }}
              className="action-dropdown-item"
            >
              <MdEdit className="text-base" />
              Edit
            </button>

            <div className="action-dropdown-divider" />

            <button
              onClick={() => {
                onAskDelete(banner._id);
                setOpenDropdownId(null);
              }}
              className="action-dropdown-item"
            >
              <MdDelete className="text-base" />
              Delete
            </button>
          </div>
        )}
      </td>
    </tr>
  );
}

export default function BannerTable({
  bannerType,
  data = [],
  loading,
  onAdd,
  onEdit,
  onDelete,
  onReorder,
}) {
  const banners = Array.isArray(data?.data) ? data.data : [];

  const [deleteId, setDeleteId] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerData, setViewerData] = useState(null);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const sortedBanners = useMemo(
    () =>
      [...banners].sort(
        (a, b) => (a.priority_order || 0) - (b.priority_order || 0)
      ),
    [banners]
  );

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = sortedBanners.findIndex((b) => b._id === active.id);
    const newIndex = sortedBanners.findIndex((b) => b._id === over.id);

    const reordered = arrayMove(sortedBanners, oldIndex, newIndex);

    const payload = reordered.map((b, index) => ({
      _id: b._id,
      priority_order: index + 1,
    }));

    await onReorder(payload);
  };

  const confirmDelete = async () => {
    try {
      setDeleting(true);
      await onDelete(deleteId);
      setDeleteId(null);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <div className="table-card overflow-hidden">
        {/* Table Header Bar */}
        {/* <div className="flex items-center justify-between p-4 border-b bg-white">
          <h2 className="text-lg font-semibold text-gray-800">
            {bannerType} Banners
          </h2>

          <CustomButton
            label={`Add ${bannerType || ""} Banner`}
            icon={MdAddBox}
            iconPos="right"
            variant="solid"
            color="#02a9e0"
            onClick={onAdd}
          />
        </div> */}

        {/* Scrollable Table Container */}
        <div className="table-scroll-body">
          <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={sortedBanners.map((b) => b._id)}
              strategy={verticalListSortingStrategy}
            >
              <table className="custom-table">
                <thead className="custom-table-header">
                  <tr>
                    <th className="w-10"></th>
                    <th>Image</th>
                    <th>Banner Title</th>
                    <th className="text-center">Status</th>
                    <th className="w-16 text-center"></th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="5"
                        className="custom-table-cell py-12 text-center text-gray-500"
                      >
                        Loading banners...
                      </td>
                    </tr>
                  ) : sortedBanners.length === 0 ? (
                    <tr>
                      <td
                        colSpan="5"
                        className="custom-table-cell py-12 text-center text-gray-500"
                      >
                        No banners found
                      </td>
                    </tr>
                  ) : (
                    sortedBanners.map((b) => (
                      <SortableRow
                        key={b._id}
                        banner={b}
                        onEdit={onEdit}
                        onAskDelete={setDeleteId}
                        openViewer={(viewerPayload) => {
                          setViewerData({
                            url: viewerPayload.url,
                            type: viewerPayload.type,
                          });
                          setViewerOpen(true);
                        }}
                        openDropdownId={openDropdownId}
                        setOpenDropdownId={setOpenDropdownId}
                        openUpward={openUpward}
                        setOpenUpward={setOpenUpward}
                        dropdownRef={dropdownRef}
                      />
                    ))
                  )}
                </tbody>
              </table>
            </SortableContext>
          </DndContext>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <ConfirmModal
        open={Boolean(deleteId)}
        title="Delete Banner"
        message="This action cannot be undone. Do you want to continue?"
        confirmText="Delete"
        loading={deleting}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteId(null)}
      />

      {/* Image / Video Viewer Modal */}
      <ImageViewer
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        src={viewerData?.url}
        type={viewerData?.type}
      />
    </>
  );
}